import {SubAPI} from "./SubAPI";
import {GlazingItem, GlazingUpsert} from "./Glazing";

export class QuoteGlazing extends SubAPI {
    list(props: {project: number; alternative: number}) {
        return this.fetcher.get<GlazingItem[]>("/api/quote-glazing-items", props);
    }

    upsert(props: GlazingUpsert & {alternative: number}) {
        return this.fetcher.post<GlazingItem>("/api/quote-glazing-item", props);
    }
}
